import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	subtitle: {
		fontSize: "16px",
		lineHeight: "28px"
	},
	link: {
		color: colors.purple[600],
		"&:hover": {
			color: colors.purple[700]
		}
	},
	button: {
		background: colors.gray[50],
		color: colors.gray[800],
		fontWeight: 500,
		boxShadow: "none",
		"&:hover": {
			background: colors.gray[100],
			color: colors.gray[700],
			boxShadow: "none"
		}
	},
	buttonIcon: {
		color: colors.purple[500],
		fontSize: 16
	}
}))

export default useStyles
